import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import NavigationBar from '../../components/Navigationbar/Navigationbar';
import { post, Token, url } from '../../Script/Session';
import { Box, Button, Card, Chip, FormControl, FormLabel, Table, Textarea, Typography } from '@mui/joy';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
function ForumThemenViewer() {
    const { forenid, id } = useParams();
    const [data, setdata] = useState();
    const [wit, setWit] = useState("90.5%");
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "getthema";
        body.themenid = Number(id);
        let response = post(body, "/forum");
        console.log(response);
        setdata(JSON.parse(response));
    }, []);
    function update() {
        let body = {};
        body.token = Token.get();
        body.action = "getthema";
        body.themenid = Number(id);
        let response = post(body, "/forum");
        console.log(response);
        setdata(JSON.parse(response));
    }
    function deletethema() {
        let body = {};
        body.token = Token.get();
        body.action = "delthema";
        body.themenid = Number(id);
        let response = post(body, "/forum");
        window.history.back();
    }
    function deleintrag(eintragid) {
        let body = {};
        body.token = Token.get();
        body.action = "delbeitrag";
        body.beitragid = Number(eintragid);
        let response = post(body, "/forum");
        update();
    }
    const [create, setcreate] = useState(false);
    const [inhaltinput, setinhaltinput] = useState();
    const [files, setfiles] = useState([]);
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("Selected file:", file);
            setfiles((prevFiles) => [...prevFiles, file]);
        }
    };
    function createbeitrag(files) {

        console.log("Uploading...");

        const formData = new FormData();
        const body = {
            token: Token.get(),
            themenid: Number(id),
            inhalt: inhaltinput,
        };

        formData.append("json", JSON.stringify(body));

        // Append each file with a unique name or just as "file"
        Array.from(files).forEach((file, idx) => {
            formData.append("file", file); // use "file[]" if backend expects an array
        });

        fetch(url + "/api/forum/create_message", {
            method: "POST",
            body: formData,
        })
            .then(res => res.text())
            .then(text => {
                console.log(text);
                if (text === "OK") {
                    window.location.reload();

                }
            })
            .catch(console.error);
    }
    if (!data) {
        return (<>Loading</>)
    }


    return (
        <>
            <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>

                <Card sx={{ width: "96%", mb: 2, mt: 2 }}>
                    <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            <AccountCircleOutlinedIcon sx={{ fontSize: "2.5rem", color: "lightgray" }} />
                            <Box>

                                <Typography color="primary" level="title-lg">{data.title}</Typography>

                                <Typography mt={-0.5} sx={{ color: "gray" }} level="body-xs">
                                    {data.erstellername} 
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ gap: 2, display: "flex", height: "5%" }}>
                            <Chip color="primary">{data.Sparte}</Chip>
                            <Chip color="primary">{data.subkath}</Chip>
                            <Chip color="neutral">{data.stamp.split(":")[0] + ":" + data.stamp.split(":")[1]}</Chip>
                        </Box>
                    </Box>

                    <Typography sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>
                        {data.thema}
                    </Typography>
                    <Table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.dateien.map((item) => {
                                    return (
                                        <tr>
                                            <th>{item.name}</th>
                                            <th><Button onClick={() => window.open(
                                                `${url}/api/filedownload/${item.objectid}/${item.name}`,
                                                "_blank",
                                                "noopener,noreferrer"
                                            )}>Download</Button></th>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                    <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Button onClick={() => setcreate(true)} sx={{ width: "10%" }}>
                            Eintrag Hinzufügen
                        </Button>
                        {
                            data.editperms && (
                                <Button color='danger' onClick={() => deletethema()}>
                                    Thema Löschen
                                </Button>
                            )
                        }

                    </Box>

                </Card>
                {
                    create && (
                        <Card sx={{ mt: 2, width: "96%", mb: 2 }}>
                            <Typography level="title-md">Eintrag Hinzufügen</Typography>
                            <FormControl>
                                <FormLabel>
                                    Inhalt
                                </FormLabel>
                                <Textarea value={inhaltinput} onChange={(e) => setinhaltinput(e.target.value)} minRows={5}>
                                </Textarea>
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    Dateien
                                </FormLabel>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Aktion</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            files.map((item) => {

                                                return (
                                                    <tr>
                                                        <td>
                                                            {item.name}
                                                        </td>
                                                        <td>
                                                            <Button onClick={() => {
                                                                setfiles(prevList => prevList.filter(i => i !== item));
                                                            }} color='danger'>Entfernen</Button>
                                                        </td>
                                                    </tr>
                                                )

                                            })
                                        }


                                    </tbody>
                                </Table>
                                <Button component="label" sx={{ mt: 6, width: "10%" }}>
                                    Datei Hochladen
                                    <input
                                        type="file"
                                        hidden
                                        onChange={handleFileChange}
                                    />
                                </Button>
                            </FormControl>
                            <Button onClick={() => createbeitrag(files)} sx={{ width: "10%", mt: 2 }}>
                                Eintrag erstellen
                            </Button>
                        </Card>
                    )
                }
                {
                    data.messages.map((item) => {
                        return (
                            <Card sx={{ mt: 2, width: "96%" }}>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        <AccountCircleOutlinedIcon sx={{ fontSize: "2.5rem", color: "lightgray" }} />
                                        <Box>

                                            <Typography color="primary" level="title-lg">{item.ersteller}</Typography>

                                            <Typography mt={-0.5} sx={{ color: "gray" }} level="body-xs">
                                                {new Date(item.date).toLocaleString()}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box sx={{ gap: 2, display: "flex", height: "5%" }}>
                                        {
                                            item.candel && (
                                                <Button onClick={() => deleintrag(item.id)} color='danger'>Löschen</Button>
                                            )
                                        }
                                    </Box>
                                </Box>
                                <Typography sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>
                                    {item.message}
                                </Typography>
                                {
                                    item.dateien.length > 0 && (
                                        <Table>
                                            <thead>
                                                <th>Name</th>
                                                <th>Download</th>
                                            </thead>
                                            <tbody>
                                                {
                                                    item.dateien.map((item) => {
                                                        return (
                                                            <tr>
                                                                <td>{item.name}</td>
                                                                <td><Button>Download</Button></td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                    )
                                }


                            </Card>
                        )
                    })
                }






            </div>

            <NavigationBar state={"home"} back={false} />
        </>
    )
}

export default ForumThemenViewer
